import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type InitializeAssetsUploadMutationVariables = Types.Exact<{
  input: Types.InitializeAssetsUploadInput;
}>;


export type InitializeAssetsUploadMutation = { __typename?: 'Mutation', initializeAssetsUpload?: { __typename?: 'InitializeAssetsUploadPayload', assets?: { __typename?: 'AssetConnection', nodes: Array<{ __typename?: 'AudioAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'DocumentAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'FileAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'FolderAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'ImageAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'InteractiveAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'InteractiveLiveAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'ModelAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'UnsupportedAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'VersionStackAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'VideoAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null }> } | null } | null };


export const InitializeAssetsUpload = /*#__PURE__*/ gql`
    mutation InitializeAssetsUpload($input: InitializeAssetsUploadInput!) {
  initializeAssetsUpload(input: $input) {
    assets(page: {first: 50}) {
      nodes {
        id
        uploadUrls(maxParts: 1000)
        project {
          id
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<InitializeAssetsUploadMutation, InitializeAssetsUploadMutationVariables>;

          

          export const useInitializeAssetsUploadMutation = (options?:MutationHookOptions<InitializeAssetsUploadMutation, InitializeAssetsUploadMutationVariables>) => useMutation(InitializeAssetsUpload, options);
          

          export type InitializeAssetsUploadMutationOptions = MutationHookOptions<InitializeAssetsUploadMutation, InitializeAssetsUploadMutationVariables>;

          

          export type InitializeAssetsUploadMutationResult = ReturnType<typeof useInitializeAssetsUploadMutation>[1];

          
